const DramaMovies = [
  {
    title: 'Cherry',
    img: 'cherry.jpeg',
    synopsis: 'Two teenage cancer patients begin a life-affirming journey to visit a reclusive author in Amsterdam.',
    score: 7.7,
  },
  {
    title: 'Moonlight',
    img: 'moonlight.jpeg',
    synopsis: 'A young man attempts to navigate life and understand his identity through the struggle of love.',
    score: 5.5,
  },
  {
    title: 'Elvis',
    img: 'elvis.jpeg',
    synopsis: 'The complicated life of this star is shown in a more nuanced light.',
    score: 5.3,
  },
];

export default DramaMovies;
